import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../environments/environment';

@Injectable()
export class ClassificationService {
    constructor(private _http: HttpClient) {}

    public classificationServiceUrl: string =
        environment.backend + environment.uri.classifications;
    public classificationClassByProduct: string =
        environment.backend + environment.uri.classificationClassByProduct;
    getClassification(searchTerm, numberOfRecords) {
        return this._http.get<any>(
            this.classificationServiceUrl
                .replace('numberOfRecords', numberOfRecords)
                .replace('searchTerm', searchTerm)
        );
    }

    getClassificationFromClassesByProduct(product, id) {
        return this._http.get<any>(
            this.classificationClassByProduct
                .replace('$productType', product)
                .replace('$id', id)
        );
    }
}
